import React, { Component } from 'react';
import './button.css';
import Link from 'react-router-dom/Link'

class Button extends Component {
    render() {
        let className = 'button';
        let href = '#';

        if (this.props && this.props.color) {
            className += ' button--' + this.props.color;
        }

        if (this.props && this.props.bordercolor) {
            className += ' button__border--' + this.props.bordercolor;
        }

        if (this.props && this.props.textcolor) {
            className += ' button__text--' + this.props.textcolor;
        }

        if (this.props && this.props.href) {
            href = this.props.href;
        }

        if (this.props && this.props.active) {
            className += ' button--active';
        }

        if (this.props && this.props.grid) {
            className += ' button--grid';
        }

        if (this.props && this.props.disabled) {
            className += ' button--disabled';
        }

        return (
            <Link className={className} to={href}>
                { this.props.name }
            </Link>
        );
    }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/button.js